/** Все категории постов (для меток на карточках и бэкенда) */
export const CLUB_LIFE_CATEGORIES = [
  { id: "all", label: "Все", icon: "✨" },
  { id: "announcement", label: "Новости", icon: "📢" },
  { id: "event", label: "События", icon: "📸" },
  { id: "achievement", label: "Достижения", icon: "🏆" },
  { id: "greeting", label: "Поздравления", icon: "🎉" },
  { id: "tip", label: "Советы", icon: "📝" },
];

/** Фильтры ленты — только основные вкладки */
export const CLUB_LIFE_FEED_FILTERS = CLUB_LIFE_CATEGORIES.filter((c) =>
  ["all", "announcement", "event", "achievement"].includes(c.id),
);

/** Категории для публикации клиентом */
export const CLUB_LIFE_CLIENT_COMPOSER_CATEGORIES = CLUB_LIFE_CATEGORIES.filter((c) =>
  ["announcement", "event", "achievement"].includes(c.id),
);

/** Категории для публикации админом / тренером */
export const CLUB_LIFE_ADMIN_COMPOSER_CATEGORIES = CLUB_LIFE_CATEGORIES.filter((c) =>
  ["announcement", "event", "achievement"].includes(c.id),
);

export function clubLifeCategoryMeta(id) {
  return (
    CLUB_LIFE_CATEGORIES.find((c) => c.id === id) || {
      id,
      label: id,
      icon: "📌",
    }
  );
}
